import React, { useContext, useMemo, useState } from "react";
import "./index.css"
import { PerguntaContext } from "../../../contexts/PerguntaContext";
import DommusTabelaPaginada from "../../../components/DommusTabelaPaginada";
import { Alert, ButtonGroup, ButtonToolbar, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { PerguntaForm } from "./PerguntaForm";
import { trackPromise } from "react-promise-tracker";
import PerguntaService from "../../../services/PerguntaService";
import Swal from "sweetalert2";
import { successToast } from "../../../components/DommusToast";
import ModalDommus from "../../../components/Modal";

export function PergutasSection() {
    const { listaPerguntas, atualizarPergunta, removerPergunta } = useContext(PerguntaContext);
    const [openModal, setOpenModal] = useState(false);
    const [perguntaSelecionada, setPerguntaSelecionada] = useState({})

    const handleMudarStatus = (pergunta) => {
        let dados = {
            oculto: !pergunta.oculto,
        };

        trackPromise(PerguntaService.update(pergunta.id_pergunta, dados))
            .then((response) => {
                atualizarPergunta(response.data);
                successToast.fire('Pergunta atualizada com sucesso!');
            })
            .catch((erro) => {
                Swal.fire({
                    title: "Ooops...",
                    text: `Houve um erro ao mudar o status da pergunta. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
                    icon: 'error'
                })
            });
    };

    const handleRemovePergunta = (pergunta) => {
        Swal.fire({
            title: "Deseja realmente excluir esta pergunta?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar!",
        }).then((result) => {
            if (result.isConfirmed) {
                trackPromise(PerguntaService.delete(pergunta.id_pergunta))
                    .then(() => {
                        removerPergunta(pergunta.id_pergunta);
                        successToast.fire("Pergunta removido com sucesso!!");
                    })
                    .catch((erro) => {
                        Swal.fire({
                            title: "Ooops...",
                            text: `Houve um erro ao remover a pergunta. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
                            icon: 'error'
                        })
                    });
            }
        });
    };

    const thead = useMemo(() => {
        return (
            <tr style={{ justifyContent: "center" }}>
                <th style={{ width: "2%" }}>Código</th>
                <th style={{ width: "45%" }}>Enunciado</th>
                <th style={{ width: "13%" }}>Tipo</th>
                <th className="text-center" style={{ width: "8%" }}>
                    Status
                </th>
                <th className="text-center" style={{ width: "3%" }}>
                    Ação
                </th>
            </tr>
        );
    }, []);


    const trows = useMemo(() => {
        return listaPerguntas?.map((pergunta, index) => {
            return (
                <tr key={index}>
                    <td>{pergunta.id_pergunta}</td>
                    <td>{pergunta.enunciado}</td>
                    <td>{pergunta?.tipo_resposta_pergunta?.nome}</td>
                    <td>
                        <ButtonToolbar
                            aria-label="Toolbar with button groups"
                            className="justify-content-center"
                        >
                            {pergunta.oculto === 0 ? (
                                <>
                                    <ButtonGroup
                                        className="btn-group-toggle"
                                        aria-label="First group"
                                    >
                                        <button
                                            style={{ cursor: "auto" }}
                                            className="btn btn-success borderBtnAtivo"
                                        >
                                            Ativo
                                        </button>
                                    </ButtonGroup>
                                    <ButtonGroup
                                        className="btn-group-toggle"
                                        aria-label="Second group"
                                    >
                                        <button
                                            onClick={() => {
                                                handleMudarStatus(pergunta);
                                            }}
                                            className="btn btn-secondary borderBtnInativo"
                                        >
                                            Inativo
                                        </button>
                                    </ButtonGroup>
                                </>
                            ) : (
                                <>
                                    <ButtonGroup
                                        className="btn-group-toggle"
                                        aria-label="First group"
                                    >
                                        <button
                                            onClick={() => {
                                                handleMudarStatus(pergunta);
                                            }}
                                            className="btn btn-secondary borderBtnAtivo"
                                        >
                                            Ativo
                                        </button>
                                    </ButtonGroup>
                                    <ButtonGroup
                                        className="btn-group-toggle"
                                        aria-label="Second group"
                                    >
                                        <button
                                            style={{ cursor: "auto" }}
                                            className="btn btn-danger borderBtnInativo"
                                        >
                                            Inativo
                                        </button>
                                    </ButtonGroup>
                                </>
                            )}
                        </ButtonToolbar>
                    </td>

                    <td>
                        <div className="opcoes-perguntas d-flex justify-content-center">
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant="primary"
                                    className=""
                                >
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        as="button"
                                        onClick={() => {
                                            setPerguntaSelecionada(pergunta);
                                            setOpenModal(true);
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faEdit}
                                            color="#B5DEFF"
                                            style={{ marginRight: 10 }}
                                        />
                                        Editar
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        as="button"
                                        onClick={() => handleRemovePergunta(pergunta)}
                                    >
                                        <FontAwesomeIcon
                                            icon={faTrashAlt}
                                            color="#E05D5D"
                                            style={{ marginRight: 10 }}
                                        />
                                        Excluir
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </td>
                </tr>
            );
        });
    }, [listaPerguntas]);



    return (
        <>
          {trows?.length ? 
            <div className="perguntas-table">
                <DommusTabelaPaginada
                    linhasCabecalho={thead}
                    optionsTabela={{}}
                    linhasCorpo={trows}
                />
            </div>
            : <Alert variant="info">Nenhuma pergunta cadastrada.</Alert>
          }
            <ModalDommus
                open={openModal}
                close={() => setOpenModal(false)}
                titulo="Atualizar pergunta"
            >
              <PerguntaForm pergunta={perguntaSelecionada} closeModal={() => { setOpenModal(false) }} />
            </ModalDommus>
        </>
    )
}
